import styles from "./PrimaryButton.module.scss";
import classNames from "classnames/bind";
const cx = classNames.bind(styles);

const PrimaryButton = (props: {
  title?: string;
  icon?: React.ReactNode;
  iconPosition?: "left" | "right";
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
  type?: "button" | "submit";
  titleStyle?: React.CSSProperties;
}) => {
  const {
    title,
    icon,
    iconPosition = "left",
    onClick,
    disabled = false,
    loading = false,
    className,
    type = "button",
    titleStyle,
  } = props;

  return (
    <button
      className={cx("primary-button", className, { disabled })}
      onClick={onClick}
      disabled={disabled}
      type={type}
    >
      {loading ? (
        <div className={cx("spinner")}></div>
      ) : (
        <>
          {icon && iconPosition === "left" && icon}
          {title && <p className={cx("primary-title")} style={titleStyle}>{title}</p>}
          {icon && iconPosition === "right" && icon}
        </>
      )}
    </button>
  );
};

export default PrimaryButton;
